import React from 'react';
import PropTypes from 'prop-types';
import { AdSlot } from 'react-dfp';
import { find } from 'lodash';
import { adSettings } from '~content/main.json';
import '~styles/modules/adposition.scss';

const AdPosition = ({ positionId, overline }) => {
  const thisPosition = find(adSettings.positions, { id: positionId });

  if (!thisPosition) {
    return null;
  }

  const sizes = thisPosition.sizeMapping.reduce(
    (accumulator, sizeMap) => [...accumulator, ...sizeMap.sizes],
    [],
  );

  return (
    <div id={positionId} className="adposition">
      {overline && (
        <p className="overline bentoncond-n4">
          <span>Advertisement</span>
        </p>
      )}
      <AdSlot
        slotId={positionId}
        sizes={sizes}
        sizeMapping={thisPosition.sizeMapping}
        targetingArguments={{
          pos: thisPosition.pos,
        }}
      />
    </div>
  );
};

AdPosition.propTypes = {
  positionId: PropTypes.string.isRequired,
  overline: PropTypes.bool,
};

AdPosition.defaultProps = {
  overline: false,
};

export default AdPosition;
